import { QUESTION_TYPES, ROLES } from "./constants";

export function getFunctionalRoles(roles) {
	return roles.filter((role) => {
		return [ROLES.FOUNDER, ROLES.FUNDER, ROLES.VENDOR].includes(role);
	}, []);
}

const questionTypeDisplayName = {
	[QUESTION_TYPES.SELECT]: "DROPDOWN",
	[QUESTION_TYPES.FREE_TEXT]: "PARAGRAPH",
	[QUESTION_TYPES.TEXT]: "SINGLE LINE TEXT",
};
export function getTypeDisplayName(type) {
	return (questionTypeDisplayName[type] || type).replace(/_/g, " ");
}

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
	return item && typeof item === "object" && !Array.isArray(item);
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
	if (!sources.length) return target;
	const source = sources.shift();

	if (isObject(target) && isObject(source)) {
		for (const key in source) {
			if (isObject(source[key])) {
				if (!target[key]) Object.assign(target, { [key]: {} });
				mergeDeep(target[key], source[key]);
			} else {
				Object.assign(target, { [key]: source[key] });
			}
		}
	}

	return mergeDeep(target, ...sources);
}

export function readable(str) {
	return str.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z]+)(?=[A-Z][a-z]|$)/g, "$1 ");
}

export function getMatchId(id) {
	return id.toString().padStart(3, "0");
}

export function fillTemplate(str, vars) {
  return str.replace(/\{(.*?)\}/g, (_, key) => vars[key] || `${key}`);
}

export function formatPhone(phone) {
	if (!phone) return '';
	let countryCode, phoneNumber, extension, result;

	if (typeof phone === 'string') {
		if (!phone.trim() || phone === 'undefined') return '';
		try {
			const parsed = JSON.parse(phone);
			if (typeof parsed === 'object' && parsed !== null) {
				countryCode = parsed.countryCode;
				phoneNumber = parsed.phoneNumber;
				extension = parsed.extension;
				result = [countryCode, phoneNumber, extension].filter(Boolean).join(' ');
			} else {
				result = phone;
			}
		} catch {
			result = phone;
		}
	} else if (typeof phone === 'object') {
		countryCode = phone.countryCode;
		phoneNumber = phone.phoneNumber;
		extension = phone.extension;
		result = [countryCode, phoneNumber, extension].filter(Boolean).join(' ');
	} else {
		result = String(phone);
	}

	// Always ensure result starts with +
	if (result && !result.startsWith('+')) {
		result = `+${result.replace(/^\+/, '')}`;
	}

	return result;
}

/**
 * Safely renders a value for React. If the value is an object, returns a string representation (JSON or a property).
 * If the object has a 'service' property, it will be used by default.
 * @param {any} value - The value to render.
 * @param {string} [property] - Optional property to extract from the object.
 * @returns {string|number|null} - A string, number, or null safe for React rendering.
 */
export function renderSafeValue(value, property) {
  if (value == null) return '';
  if (typeof value === 'object') {
    // Prefer explicit property, then 'service', then JSON
    if (property && value[property] !== undefined) {
      return value[property];
    }
    if (value.service !== undefined) {
      return value.service;
    }
    try {
      return JSON.stringify(value);
    } catch (e) {
      return '[Object]';
    }
  }
  return value;
}
